"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HiddenRefElement = void 0;
var _react = _interopRequireDefault(require("react"));
/**
 * useTextFromRef
 * @description
 * Exports an element ref using useRef, that then extracts the basic text content from it,
 * and returns it for use in element TITLE/ALT attributes.  This is needed because HTML/REACT
 * cannot render JSX objects in TITLE/ALT attributes, like translated content.
 *
 * @exports ref: a useRef reference that should be attached to the needed element
 * @exports text: a basic text string extracted from the ref element
 *
 * @example usage example where multiple refs are needed:
 *          'const labelRef = useTextFromRef();'
 *          '<button title={labelRef.text}><span ref={labelRef.ref}><Trans>Click Here</Trans></button>'
 *
 * @example alternate usage example:
 *          'const {ref, text} = useTextFromRef();'
 *          '<button title={text}><span ref={ref}><Trans>Click Here</Trans></button>'
 */
const useTextFromRef = () => {
  const ref = _react.default.useRef(null);
  const [text, setText] = _react.default.useState(null);
  _react.default.useEffect(() => {
    if (ref.current) {
      setText(ref.current.textContent);
    }
  }, [ref, setText]);
  return {
    ref,
    text
  };
};

/**
 * HiddenRefElement
 * @description
 * Additional component to help extract text from a React object, that is also hidden from the users view as well as screenreaders
 *
 * @prop ref: a useRef reference that should be attached to the HiddenRefElement
 *
 * @example usage example:
 *          'const labelRef = useTextFromRef();'
 *          '<button title={labelRef.text}>'
 *            '<Trans>Click Here</Trans>'
 *            '<HiddenRefElement ref={labelRef.ref}>'
 *              '<Trans>Click here to view Deals</Trans>'
 *            '</HiddenRefElement>'
 *          '</button>'
 */
const HiddenRefElement = exports.HiddenRefElement = /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement("span", {
  ref: ref,
  "aria-hidden": "true",
  adc: "hidden"
}, props.children));
var _default = exports.default = useTextFromRef;